import { environment } from '@environments/environment';

export const GET_HANDLES_QUERY = (langcode: string, type_produit: string, filters?: string[]) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              type_produit,
            },
          },
          ...(filters && filters?.length > 0 ? [{ terms: { field_handle_style: filters } }] : []),
        ],
      },
    },
    _source: ['title', 'field_style_et_couleur', 'field_handle_style'],
  },
});
